module.exports = __webpack_public_path__ + "static/media/popradio.68ef8b3f.jpg";